module.exports = __webpack_public_path__ + "static/media/saffron1_preview.19a48727.jpg";